import { render, staticRenderFns } from "./agency.vue?vue&type=template&id=8a8af114&scoped=true&"
import script from "./agency.vue?vue&type=script&lang=js&"
export * from "./agency.vue?vue&type=script&lang=js&"
import style0 from "./agency.vue?vue&type=style&index=0&id=8a8af114&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a8af114",
  null
  
)

export default component.exports